module.exports = __webpack_public_path__ + "static/media/pattern6.ca17b03b.svg";